import * as THREE from "three";
import {XRControllerModelFactory} from "three/examples/jsm/webxr/XRControllerModelFactory.js";
import {XRHandModelFactory} from "three/examples/jsm/webxr/XRHandModelFactory.js";
export default class VRControl {
  constructor(
    camera,
    targetBody,
    renderer,
    scene,
    executeOnclickFunction,
    handleJoystickDirectionChange,
    onVRControllerRightSqueezeStart,
    onVRControllerRightSqueezeEnd,
    onVRControllerLeftSqueezeStart,
    onVRControllerLeftSqueezeEnd,
  ) {
    this.camera = camera;
    this.targetBody = targetBody;
    this.renderer = renderer;
    this.scene = scene;
    this.executeOnclickFunction = executeOnclickFunction;
    this.handleJoystickDirectionChange = handleJoystickDirectionChange;

    this.onVRControllerRightSqueezeStart = onVRControllerRightSqueezeStart;
    this.onVRControllerRightSqueezeEnd = onVRControllerRightSqueezeEnd;
    this.onVRControllerLeftSqueezeStart = onVRControllerLeftSqueezeStart;
    this.onVRControllerLeftSqueezeEnd = onVRControllerLeftSqueezeEnd;

    this.joystickRadian = 0;
    this.previousCameraPos = new THREE.Vector3();
    this.previousCameraQuaternion = new THREE.Quaternion();
    this.init_();
  }

  init_() {
    //setup
    this.avatarInit();
    this.cameraInit();
    this.dummy = new THREE.Object3D();
    this.dummy.add(this.camera);
    this.targetBody.add(this.dummy);
    this.raycaster = new THREE.Raycaster();
    this.handleOnClick = this.handleOnClick.bind(this);
    this.getIntersections = this.getIntersections.bind(this);
    this.handleOnClickEnd = this.handleOnClickEnd.bind(this);
    this.addGamePad1 = this.addGamePad1.bind(this);
    this.addGamePad2 = this.addGamePad2.bind(this);
    this.addController();
    this.tempMatrix = new THREE.Matrix4();
  }
  avatarInit() {
    if (this.targetBody.userData?.type !== "avatar") return;
    this.avatar = this.targetBody.manager;
    this.avatar.model.body.transform();
    this.avatar.model.body.setRotation(0, 0, 0);
    this.avatar.model.body.refresh();
    this.avatar.model.children[0].visible = false;
    this.avatar.changeNicknameVisibility(false);
  }
  cameraInit() {
    this.previousCameraPos.copy(this.camera.position);
    this.previousCameraQuaternion.copy(this.camera.quaternion);
    this.camera.position.copy(this.targetBody.position);
    this.isFPSControls = true;
    this.camera.near = 0.05;
    //set for rotation
    this.rotation_ = new THREE.Quaternion();
    this.phiSpeed_ = 0.03;
    this.phi_ = 0;
  }

  addController() {
    const controllerModelFactory = new XRControllerModelFactory();
    // const handModelFactory = new XRHandModelFactory().setPath("path_to_hand_models/");
    // this.controller = false;

    this.controller1 = this.renderer.xr.getController(0);
    this.controller2 = this.renderer.xr.getController(1);

    this.controller1.addEventListener("connected", this.addGamePad1);

    this.controller2.addEventListener("connected", this.addGamePad2);

    this.controller2.addEventListener("selectstart", this.handleOnClick);
    this.controller2.addEventListener("selectend", this.handleOnClickEnd);
    this.controller1.addEventListener("selectstart", this.handleOnClick);
    this.controller1.addEventListener("selectend", this.handleOnClickEnd);

    if (this.avatar) {
      this.controller2.addEventListener("squeezestart", this.onVRControllerRightSqueezeStart);
      this.controller2.addEventListener("squeezeend", this.onVRControllerRightSqueezeEnd);
      this.controller1.addEventListener("squeezestart", this.onVRControllerLeftSqueezeStart);
      this.controller1.addEventListener("squeezeend", this.onVRControllerLeftSqueezeEnd);
    }
    this.controllerGrip1 = this.renderer.xr.getControllerGrip(0);
    this.controllerGrip2 = this.renderer.xr.getControllerGrip(1);
    // this.hand1 = this.renderer.xr.getHand(0);
    // this.hand2 = this.renderer.xr.getHand(1);
    this.addLines();

    this.controllerGrip1.add(controllerModelFactory.createControllerModel(this.controllerGrip1));
    this.controllerGrip2.add(controllerModelFactory.createControllerModel(this.controllerGrip2));
    // this.hand1.add(handModelFactory.createHandModel(this.hand1, "boxes"));
    // this.hand2.add(handModelFactory.createHandModel(this.hand2, "boxes"));

    this.dummy.add(this.controller1);
    this.dummy.add(this.controller2);

    this.dummy.add(this.controllerGrip1);
    this.dummy.add(this.controllerGrip2);

    // this.dummy.add(this.hand1);
    // this.dummy.add(this.hand2);
  }

  handleOnClick(event) {
    const controller = event.target;
    const intersections = this.getIntersections(controller);
    if (intersections.length > 0) {
      const intersection = intersections[0];
      this.executeOnclickFunction(intersection.object);
    }

    controller.userData.targetRayMode = event.data.targetRayMode;
  }

  getIntersections(controller) {
    controller.updateMatrixWorld();

    this.tempMatrix.identity().extractRotation(controller.matrixWorld);

    this.raycaster.ray.origin.setFromMatrixPosition(controller.matrixWorld);
    this.raycaster.ray.direction.set(0, 0, -1).applyMatrix4(this.tempMatrix);

    return this.raycaster
      .intersectObjects(this.scene.children)
      .filter(intersect => intersect.object.userData.playInfo && intersect.object.userData.playInfo.isAlive === true);
  }

  handleOnClickEnd(event) {
    // if (!this.controller || !this.controller2.gamepad.axes[2]) return;
  }

  addLines() {
    const geometry = new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, -1)]);

    const line = new THREE.Line(geometry);
    line.name = "line";
    line.scale.z = 5;

    this.controller1.add(line.clone());
    this.controller2.add(line.clone());
  }

  addGamePad1(event) {
    if ("gamepad" in event.data) {
      if ("axes" in event.data.gamepad) {
        this.controller1.gamepad = event.data.gamepad;
      }
    }
  }
  addGamePad2(event) {
    if ("gamepad" in event.data) {
      if ("axes" in event.data.gamepad) {
        this.controller2.gamepad = event.data.gamepad;
      }
    }
  }
  removeController() {
    this.controller1.removeEventListener("connected", this.addGamePad1);

    this.controller2.removeEventListener("connected", this.addGamePad2);

    this.controller2.removeEventListener("selectstart", this.handleOnClick);
    this.controller2.removeEventListener("selectend", this.handleOnClickEnd);
    this.controller1.removeEventListener("selectstart", this.handleOnClick);
    this.controller1.removeEventListener("selectend", this.handleOnClickEnd);

    if (this.avatar) {
      this.controller2.removeEventListener("squeezestart", this.onVRControllerRightSqueezeStart);
      this.controller2.removeEventListener("squeezeend", this.onVRControllerRightSqueezeEnd);
      this.controller1.removeEventListener("squeezestart", this.onVRControllerLeftSqueezeStart);
      this.controller1.removeEventListener("squeezeend", this.onVRControllerLeftSqueezeEnd);
    }

    this.dummy.remove(this.controller1);
    this.dummy.remove(this.controller2);

    this.dummy.remove(this.controllerGrip1);
    this.dummy.remove(this.controllerGrip2);

    // this.dummy.remove(this.hand1);
    // this.dummy.remove(this.hand2);
  }

  update(dt) {
    this.controllerUpdate(dt);
    //calculate deltaQuaternion of dummy
    let quaternionDifference = this.dummy.quaternion.multiply(this.rotation_.clone().invert());
    //change quaternion of dummy
    this.dummy.quaternion.copy(this.rotation_);
    //remove deltaQuaternion from camera
    this.camera.quaternion.copy(this.camera.quaternion.multiply(quaternionDifference.clone().invert()));
  }

  controllerUpdate(_) {
    if (this.controller1.gamepad?.axes[2] === undefined || this.controller2.gamepad?.axes[2] === undefined) return;
    const xh = this.controller1.gamepad.axes[2];
    this.phi_ += -xh * this.phiSpeed_;
    const qx = new THREE.Quaternion();
    qx.setFromAxisAngle(new THREE.Vector3(0, 1, 0), this.phi_);
    this.rotation_.copy(qx);

    if (this.avatar) {
      this.handleJoystickDirectionChange(this.controller2.gamepad.axes[2], this.controller2.gamepad.axes[3]);
    }
  }

  dispose() {
    this.dummy.remove(this.camera);
    if (this.avatar) {
      this.avatar.model.children[0].visible = true;
      this.avatar.changeNicknameVisibility(true);
    }
    this.targetBody.remove(this.dummy);
    this.removeController();
    this.camera.near = 1;
    this.camera.position.copy(this.previousCameraPos);
    this.camera.quaternion.copy(this.previousCameraQuaternion);
    this.camera.lookAt(this.targetBody.position.x, this.targetBody.position.y + 5, this.targetBody.position.z);
    this.camera.updateProjectionMatrix();
  }
}
